var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-header" }, [
    _c("div", { staticClass: "app-header__header" }, [
      _vm.$route.meta.origin !== undefined
        ? _c(
            "div",
            { staticClass: "app-header__section" },
            [
              _c("AppImage", {
                staticClass: "app-header__logo app-header__logo--small",
                attrs: { src: require("@/assets/img/upmood-logo.svg") },
                on: {
                  click: function($event) {
                    _vm.$router.push({ name: "dashboard" }).catch(function() {})
                  }
                }
              }),
              _vm._v(" "),
              _c("AppIcon", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$route.name !== "upmood-mass-view",
                    expression: "$route.name !== 'upmood-mass-view'"
                  }
                ],
                staticClass: "app-header__arrow",
                attrs: { "icon-name": "arrowLeft" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c(
                "h4",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$route.name !== "upmood-mass-view",
                      expression: "$route.name !== 'upmood-mass-view'"
                    }
                  ],
                  staticClass: "app-header__name"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("back")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "app-header__section" },
            [
              _c("AppImage", {
                staticClass: "app-header__logo",
                attrs: {
                  src: require("@/assets/img/upmood-brand.svg"),
                  title: "Upmood"
                },
                on: {
                  click: function($event) {
                    _vm.$router.push({ name: "dashboard" }).catch(function() {})
                  }
                }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.closeUserMenu,
              expression: "closeUserMenu"
            }
          ],
          staticClass: "app-header__section",
          on: {
            click: function($event) {
              _vm.showUserMenu = !_vm.showUserMenu
            }
          }
        },
        [
          _c("AppImage", {
            staticClass: "app-header__avatar",
            attrs: {
              src: require("@/assets/img/default-avatar.png"),
              fallback: require("@/assets/img/default-avatar.png"),
              title: "avatar"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "app-header__username" }, [
            _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.username) + "\n\t\t\t\t")
          ]),
          _vm._v(" "),
          _vm.showUserMenu
            ? _c(
                "p",
                {
                  staticClass: "app-header__logout",
                  on: { click: _vm.signOut }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$t("logout")) + "\n\t\t\t\t"
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.$route.meta.origin === undefined
      ? _c(
          "ul",
          {
            directives: [
              {
                name: "on-clickaway",
                rawName: "v-on-clickaway",
                value: _vm.closeSubMenu,
                expression: "closeSubMenu"
              }
            ],
            staticClass: "app-header__nav"
          },
          [
            _vm._l(_vm.routes, function(route) {
              return _c(
                "li",
                {
                  key: route.label,
                  staticClass: "link",
                  class: { "link--active": _vm.isRouteActive(route) },
                  on: {
                    click: function($event) {
                      return _vm.routeClickHandler(route)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\n\t\t\t\t" +
                      _vm._s(_vm.$t(route.label)) +
                      "\n\n\t\t\t\t"
                  ),
                  route.link instanceof Array
                    ? [
                        _c("span", { staticClass: "link__arrow" }),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "link__sub" },
                          _vm._l(route.link, function(subRoute) {
                            return _c(
                              "li",
                              {
                                key: subRoute.label,
                                staticClass: "link",
                                class: {
                                  "link--active": _vm.isRouteActive(subRoute)
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.routeClickHandler(subRoute)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t(subRoute.label)) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "AppButton",
                  {
                    staticClass: "link__button",
                    attrs: { modifier: "large-primary" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ name: "session-create" })
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("create_session")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e922ff1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e922ff1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppHeader.vue
// module id = null
// module chunks = 